import * as npntraining from "./global_config_npntraining.js";
import * as corporate   from "./global_config_corporate.js";

const configs = {
  npntraining,
  corporate,
};

// Read VITE_CONFIG from .env — fallback to npntraining
const active = configs[import.meta.env.VITE_CONFIG] || npntraining;

export const coursesList     = active.coursesList;
export const timer           = active.timer;
export const sessionDuration = active.sessionDuration;